import React, { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { Button } from './Button';
import { Icon } from './Icon';
import { PopoverH } from './TooltipH';

const toAntdPlacement = (value = 'bottomRight') =>
  String(value).replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());

export const UserDropDown = React.memo(({
  mobileIconsOnly,
  listId,
  actions = [],
  avatar = {},
  user = {},
  penta = {},
  addComponentFirst,
  addComponent,
  placement = 'bottom-right'
}) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }
  const $ui = context.$ui;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const allActions = {
    edit: {
      title: $ui('but_edit_profile_short'),
      icon: 'edit',
      action: ({ user, avatar }) => navigate(`/u/${avatar.token}/info#p=bodygraphs`)
    },
    share: {
      title: $ui('but_public_link_short'),
      icon: 'share',
      action: ({ user, avatar }) => navigate(`/u/${user.token}/info#p=people`)
    },
    delete: {
      title: $ui('but_body_delete_short'),
      icon: 'delete',
      red: true,
      action: ({ avatar }) => {
        if (!avatar.isMe) {
          context.x.deleteAvatar({ avatar: avatar })
          context.setState.setShowHistory([avatar.token, user?.token].filter(Boolean), true)
        }
      },
    },
    deleteFromHistory: {
      title: $ui('but_body_delete_history_short'),
      icon: 'hide_source',
      red: true,
      action: ({ avatar, penta, user }) => {
        const token = penta?.token || avatar?.token;
        const related = [token, user?.token].filter(Boolean);
        context.setState.setShowHistory(related, true);
      },
    },
    deletePenta: {
      title: $ui('penta_delete'),
      icon: 'delete',
      red: true,
      action: context.x.deletePenta,
    },
    addToPenta: {
      title: $ui('penta_add_people'),
      icon: 'person_add',
    },
    follow: {
      title: ({ user }) => context.x.checkIfFollow(user.token) ? $ui('but_unfollow') : $ui('but_follow'),
      icon: ({ user }) => context.x.checkIfFollow(user.token) ? 'person_remove' : 'person_add',
      action: ({ user, avatar }) => (context.x.checkIfFollow(user.token) ? context.x.unfollow : context.x.follow)({ user, avatar }),
    }
  }


  const isCurrentUser = () => {
    const me = context.me;
    if (!me) return false;
    return user?.isMe
      || avatar?.isMe
      || (user?.token && user.token === me.user?.token)
      || (avatar?.token && avatar.token === me.avatar?.token);
  };

  const checkIsMe = (actions) => {
    const list = Array.isArray(actions) ? actions : [];
    const me = isCurrentUser();

    if (me && list.includes('follow')) {
      return ['edit', 'share'];
    }

    return list.filter((one) => {
      if (typeof one === 'object') {
        if (one?.noMe && me) return false;
        if (one?.onlyMe && !me) return false;
      }
      if (typeof one === 'string' && one === 'delete' && avatar && (avatar.isMe || !avatar.my)) {
        return false;
      }
      return true;
    });
  }

  const resolveAction = (one) => {
    if (typeof one === 'string') {
      return allActions[one] || null;
    }
    if (one && typeof one === 'object' && typeof one.action === 'function') {
      return one;
    }
    return null;
  }

  const actionItems = checkIsMe(Array.isArray(actions) ? actions : [])
    .map((one, ind) => {
      const item = resolveAction(one);
      if (!item) return null;
      return {
        key: typeof one === 'string' ? one : `custom_${ind}`,
        item,
      };
    })
    .filter(Boolean);

  const hasMenuContent = actionItems.length > 0 || Boolean(addComponentFirst) || Boolean(addComponent);
  if (!hasMenuContent) return null;

  const closeMenu = () => setOpen(false);

  const runAction = (item) => {
    closeMenu();
    if (typeof item?.action === 'function') {
      item.action({ avatar, user, penta });
    }
  };

  const menu = (
    <div className={`x_choose_one_menu_ul shown ${mobileIconsOnly ? 'x_choose_one_menu_ul--mobile' : ''}`} 
      onClick={(e) => e.stopPropagation()}>
      {addComponentFirst && <div onClick={closeMenu}>{addComponentFirst}</div>}

      {actionItems.map(({ key, item }) => {
        const icon = typeof item.icon === 'function' ? item.icon({ user }) : item.icon;
        const title = typeof item.title === 'function' ? item.title({ user }) : item.title;
        const isDestructive = Boolean(item.red) || icon === 'delete' || icon === 'person_remove';

        return (
          <Button
            key={`${listId}_${avatar.token}_${key}`}
            className="_f100"
            sm={!mobileIconsOnly}
            ghost={!isDestructive}
            red={isDestructive}
            icon={icon}
            labelMobileOff={mobileIconsOnly}
            onClick={() => runAction(item)}
          >
            {title}
          </Button>
        );
      })}

      {addComponent && <div onClick={closeMenu}>{addComponent}</div>}
    </div>
  );

  return (
    <div
      className="x_choose_one_menu0"
      onClick={(e) => e.stopPropagation()}
    >
      <PopoverH
        // trigger="click"
        open={open}
        onOpenChange={setOpen}
        placement={toAntdPlacement(placement)}
        arrow={false}
        overlayClassName="x_choose_one_popover"
        content={menu}
      >
        <div className="x_choose_one_menu_ico">
          <Icon size={20} icon="more_vert" />
        </div>
      </PopoverH>
    </div>
  )
})


export const UserDropDownOld = React.memo(({
  mobileIconsOnly,
  listId,
  actions = [],
  avatar = {},
  user = {},
  penta = {},
  addComponentFirst,
  addComponent,
  placement = 'bottom-left'
}) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }
  const $ui = context.$ui;
  const navigate = useNavigate();

  const allActions = {
    edit: {
      title: $ui('but_edit_profile_short'),
      icon: 'edit',
      action: ({ user, avatar }) => navigate(`/u/${avatar.token}/info#p=bodygraphs`)
    },
    share: {
      title: $ui('but_public_link_short'),
      icon: 'share',
      action: ({ user, avatar }) => navigate(`/u/${user.token}/info#p=people`)
    },
    // setMe: {
    //   'title': 'Set Me',
    //   'icon': 'person',
    //   'action': context.x.setIsMe,
    // },
    // invite: {
    //   'title': 'Invite',
    //   'icon': 'person',
    //   'action': () => void (0),
    // },
    // share: {
    //   'title': 'Share',
    //   'icon': 'share',
    //   'action': () => void (0),
    // },
    delete: {
      'title': $ui('but_body_delete_short'),
      'icon': 'delete',
      'action': ({ avatar }) => {
        if (!avatar.isMe) {
          context.x.deleteAvatar({ avatar: avatar })
          context.setState.setShowHistory([avatar.token, user?.token].filter(Boolean), true)
        }
      },
    },
    deleteFromHistory: {
      'title': $ui('but_body_delete_history_short'),
      'icon': 'hide_source',
      'action': ({ avatar, penta, user }) => {
        const token = penta?.token || avatar?.token;
        const related = [token, user?.token].filter(Boolean);
        context.setState.setShowHistory(related, true);
      },
    },
    deletePenta: {
      'title': $ui('penta_delete'),
      'icon': 'delete',
      'action': context.x.deletePenta,
    },
    addToPenta: {
      'title': $ui('penta_add_people'),
      'icon': 'person_add',
    },
    follow: {
      'title': ({ user }) => context.x.checkIfFollow(user.token) ? $ui('but_unfollow') : $ui('but_follow'),
      'icon': ({ user }) => context.x.checkIfFollow(user.token) ? 'person_remove' : 'person_add',
      'action': ({ user, avatar }) => (context.x.checkIfFollow(user.token) ? context.x.unfollow : context.x.follow)({ user, avatar }),
    }
  }


  const isCurrentUser = () => {
    const me = context.me;
    if (!me) return false;
    return user?.isMe
      || avatar?.isMe
      || (user?.token && user.token === me.user?.token)
      || (avatar?.token && avatar.token === me.avatar?.token);
  };

  const checkIsMe = (actions) => {
    const list = Array.isArray(actions) ? actions : [];

    if (isCurrentUser() && list.includes('follow')) {
      return ['edit', 'share'];
    }

    if (avatar && (avatar.isMe || !avatar.my)) {
      return list.filter(one => one !== 'delete');
    }
    return list;
  }

  const resolveAction = (one) => {
    if (typeof one === 'string') {
      return allActions[one] || null;
    }
    if (one && typeof one === 'object' && typeof one.action === 'function') {
      return one;
    }
    return null;
  }

  const actionItems = checkIsMe(Array.isArray(actions) ? actions : [])


  const [shown, setShown] = useState(false);
  const [shownInner, setShownInner] = useState(shown);
  const dropdownRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the component
      if (shown && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShown(false);
      }
    };
    if (shown !== shownInner) {
      setTimeout(() => {
        setShownInner(shown);
      }, 50);
    }

    const handleMouseMove = (event) => {
      // Check if the mouse is outside the dropdown
      if (shown && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, [shown]);



  return (
    <div
      ref={dropdownRef}
      className={shown ? "x_choose_one_menu0 active" : "x_choose_one_menu0"}
      onClick={(e) => {
        e.stopPropagation()
        setShown(!shown)
      }}
    >
      <div className="x_choose_one_menu_ico">
        <div className="t_icon t_icon--20">
          <div>more_vert</div>
        </div>
      </div>
      <div className={shown ? "x_choose_one_menu_drop active" : "x_choose_one_menu_drop"}>
        <div className={`x_choose_one_menu_ul ${mobileIconsOnly ? 'x_choose_one_menu_ul--mobile' : ''} ${shownInner ? 'shown' : ''}`}>

          {addComponentFirst}

          {actionItems.map((one, ind) => {
            const item = resolveAction(one);
            if (!item) return null;
            const actionKey = typeof one === 'string' ? one : `custom_${ind}`;
            return <div
              key={`${listId}_${avatar.token}_${actionKey}`}
              className={`x_choose_one_menu_li w-inline-block ${mobileIconsOnly ? 'x_choose_one_menu_li--mobile' : ''}`}
              onClick={() => {
                item.action({ avatar: avatar, user: user, penta: penta })
              }}
            >
              
              {typeof item.icon === 'function' ? <Icon size={20} icon={item.icon({ user: user })} /> : <Icon size={20} icon={item.icon} />}
              {typeof item.title === 'function' ? <span className={mobileIconsOnly ? 'mobile_vh_no' : ''}>{item.title({ user: user })}</span> : <span className={mobileIconsOnly ? 'mobile_vh_no' : ''}>{item.title}</span>}
            </div>
          })}

          {addComponent}
          {/* <a href="#" className="x_choose_one_menu_li w-inline-block"
            onClick={() => {
              context.setState.showPeople(false)

            }}
          >
            <div className="t_icon t_icon--20">
              <div>edit</div>
            </div>
            <div>Edit</div>
          </a> */}


          {/* <a href="#" className="x_choose_one_menu_li w-inline-block">
            <div className="t_icon t_icon--20">
              <div>people</div>
            </div>
            <div>Invite</div>
          </a> */}
          {/* <a href="#" className="x_choose_one_menu_li w-inline-block">
            <div className="t_icon t_icon--20">
              <div>share</div>
            </div>
            <div>Share</div>
          </a> */}


          {/* {actions.map(one => {
            return (<div className="x_choose_one_menu_li x_choose_one_menu_li--2 w-inline-block"
              onClick={(e) => {
                // context.handles.deleteUser(userId)
                one.action(avatar.token)
              }}
            >
              <div className="t_icon t_icon--20">
                <div>delete</div>
              </div>
              {one.title}
            </div>)
          })} */}


          {/* {userId === context['user']['userData']['id'] && <a href="#" className="x_choose_one_menu_li x_choose_one_menu_li--2 w-inline-block">
            This is you
          </a>} */}
        </div>
      </div>
    </div>
  )
})